import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initMonitoring } from "@shared/lib/monitoring/sentry";

// 에러 모니터링 초기화(DSN 미설정 시 no-op). 렌더 전에 호출해 전역 핸들러를 먼저 건다.
initMonitoring();

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

// StrictMode 는 개발용 점검 도구다(effect 더블-인보크 등은 dev 빌드에서만 동작).
// dev 에서 켜서 잠재 버그를 조기에 드러내고, prod 는 끈다(불필요).
const Wrapper =
    process.env.NODE_ENV === "production" ? React.Fragment : React.StrictMode;

root.render(
    <Wrapper>
        <App/>
    </Wrapper>
);

reportWebVitals();
